
  import { css } from 'lit';
  export const styles = css`:host{--color: var(--ig-label-color, var(--ig-gray-600));--disabled-color: var(--ig-label-disabled-color, hsl(from var(--ig-gray-900) h s l/0.2));--ig-theme: indigo;--ig-theme-variant: light}`;
  